import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgLeaderboardEmptyStateThird = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 89,
  height: 104,
  viewBox: "0 0 89 104",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsx("rect", {
    width: 87.407,
    height: 87.997,
    x: 0.666,
    y: 16.001,
    fill: "#FFD863",
    rx: 12.837
  }), /*#__PURE__*/_jsx("circle", {
    cx: 44.365,
    cy: 24.011,
    r: 18.679,
    fill: "#4D4216"
  }), /*#__PURE__*/_jsx("circle", {
    cx: 44.365,
    cy: 24.011,
    r: 18.679,
    fill: "#4D4216"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#4D4216",
    d: "M58.803 58.848c.485 2.424-1.913 4.419-4.209 3.5l-9.073-3.629a3.11 3.11 0 0 0-2.313 0l-9.074 3.63c-2.295.918-4.693-1.077-4.209-3.501l2.795-13.977c.211-1.056 1.408-1.585 2.383-1.127a21.7 21.7 0 0 0 9.261 2.06c3.312 0 6.45-.739 9.26-2.06.975-.459 2.172.07 2.383 1.127z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#FFD863",
    d: "M43.41 33.856q-1.419 0-2.79-.349-1.369-.347-2.34-1.046l.896-3.088q.797.373 1.719.598.945.2 1.892.199 1.147 0 1.918-.299.773-.323 1.17-.872.4-.572.4-1.295a2.2 2.2 0 0 0-.424-1.345q-.423-.597-1.27-.896-.822-.3-1.993-.3a7 7 0 0 0-1.893.25l3.935-6.85 1.345.922h-7.347V15.9H50.21l-4.383 7.696-1.046-1.196q1.668 0 2.939.748a5.1 5.1 0 0 1 1.967 1.967q.723 1.245.723 2.765 0 1.619-.847 2.988-.822 1.37-2.416 2.192-1.569.797-3.736.797"
  })]
});
export default SvgLeaderboardEmptyStateThird;